export const initialState = {
  users: [],
  data: [],
  homescreen: [],
  homescreenLoading: false,
  homescreenError: null,
  forms: [],
  popups: [],
  scrolls: [],
  useremail: {},
  useremail404: false,
};

const api = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_DATA':
      return {
        ...state,
        data: action.data,
      };
    case 'GET_HOMESCREEN_LOADING':
      return {
        ...state,
        homescreenLoading: true,
        homescreenError: null,
      };
    case 'GET_HOMESCREEN_SUCCESS':
      return {
        ...state,
        homescreen: action.data,
        homescreenLoading: false,
        homescreenError: null,
      };
    case 'GET_HOMESCREEN_ERROR':
      return {
        ...state,
        homescreenLoading: false,
        homescreenError: 'Failed to load homescreen data',
      };
    case 'UPDATE_HOMESCREEN_SIZE_SUCCESS':
    case 'UPDATE_HOMESCREEN_WEEK_SUCCESS':
      return {
        ...state,
        homescreenError: null,
      };
    case 'UPDATE_HOMESCREEN_SIZE_ERROR':
    case 'UPDATE_HOMESCREEN_WEEK_ERROR':
      return {
        ...state,
        homescreenError: 'Failed to update homescreen data',
      };
    case 'GET_FORM':
      return {
        ...state,
        forms: action.data.data,
      };
    case 'GET_FORM_ERROR':
      return {
        ...state,
        forms: [],
      };
    case 'GET_USER_EMAIL':
      return {
        ...state,
        useremail: action.data,
        useremail404: false,
      };
    case 'GET_USER_EMAIL_ERROR':
      return {
        ...state,
        useremail: {},
        useremail404: true,
      };
    case 'GET_USER_EMAIL_ERROR_DELETE':
      return {
        ...state,
        useremail: {},
        useremail404: false,
      };
    case 'GET_USERS':
      return {
        ...state,
        users: action.data,
      };
    case 'DELETE_USER':
      return {
        ...state,
        useremail: {},
      };
    /******************** POPUPS ***********************/
    case 'GET_POPUPS':
      return {
        ...state,
        popups: action.data,
      };
    case 'GET_POPUPS_ERROR':
      return {
        ...state,
        popups: [],
      };
    /******************** SCROLLS ***********************/
    case 'GET_SCROLLS':
      return {
        ...state,
        scrolls: action.data,
      };
    case 'GET_SCROLLS_ERROR':
      return {
        ...state,
        scrolls: [],
      };
    /******************** DEFAULT ***********************/
    default:
      return state;
  }
};

export default api;
